//Flickity Slider
import Flickity from 'flickity';
import 'flickity-imagesloaded/flickity-imagesloaded';

export function initFullWidthCarousel() {
    if (window.acf) {
        window.acf.addAction(
            'render_block_preview/type=full-width-carousel',
            fullWidthCarousel
        );
    }
}

export function fullWidthCarousel() {

    if (document.querySelector('.full-width-carousel')) {
        if (document.querySelectorAll('.full-width-carousel--items').length > 1) {
            var fullWidthC = new Flickity('.full-width-carousel', {
                cellSelector: '.full-width-carousel--items',
                autoPlay: 3000,
                pageDots: false,
                prevNextButtons: true,
                groupCells: true,
                cellAlign: 'left',
                imagesLoaded: true,
                wrapAround: true,
                arrowShape: 'M1.288 37.153L34.252 1.556a4.832 4.832 0 016.838-.266 4.841 4.841 0 01.267 6.838L15.914 35.6H95.16a4.842 4.842 0 014.84 4.84 4.842 4.842 0 01-4.84 4.84H16.2L40.635 70.71a4.844 4.844 0 01-.135 6.844 4.837 4.837 0 01-6.848-.14l-32.3-33.622a4.837 4.837 0 01-.064-6.64'
            });
        }
    }
}
